import * as types from './mutation-types'

export const loadNationalities = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/nationalities', data).then((response) => {
            commit(types.LOAD_NATIONALITIES, response.data.nationality)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createOrUpdateEmployeFolder = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/employee', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('change/'+data?.id+'/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    }) 
}


export const getEmployeFolder = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/'+id+'/employee').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
